export const whenEnter =
 (callBack: (e: React.KeyboardEvent<any>) => void) =>
 (e: React.KeyboardEvent<HTMLInputElement>) => {
  if (e.key === "Enter") {
   callBack(e);
  }
 };
